module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fontawesome-webfont.woff?v=4.7.0
// module chunks = 40